import { api } from '../api/nocode';

function getRows(response) {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.data)) return response.data;
  return [];
}

function getCreatedId(response) {
  const candidates = [
    response?.id,
    response?.data?.id,
    response?.data?.data?.id
  ];

  return candidates.find(
    (value) => value !== null && value !== undefined && value !== ''
  ) ?? null;
}

async function findCampUserByEmail(email) {
  const normalizedEmail = (email ?? '').trim().toLowerCase();
  const response = await api.get('users_gwacamp');

  return getRows(response).find(
    (row) => (row?.email ?? '').trim().toLowerCase() === normalizedEmail
  ) ?? null;
}

export async function resolveCreatedCampUserId(createResponse, email) {
  const createdId = getCreatedId(createResponse);
  if (createdId !== null) return createdId;

  for (let attempt = 0; attempt < 3; attempt += 1) {
    const user = await findCampUserByEmail(email);
    if (user?.id !== null && user?.id !== undefined && user?.id !== '') {
      return user.id;
    }

    await new Promise((resolve) => window.setTimeout(resolve, 250));
  }

  throw new Error('Your Camp profile was created, but its server ID could not be confirmed.');
}

export async function ensureCampUserOwner(user) {
  if (!user?.id) {
    throw new Error('Your Camp profile is missing its server ID.');
  }

  const userId = String(user.id);
  if (String(user?.owner_id ?? '') === userId) {
    return user;
  }

  await api.put('users_gwacamp', user.id, { owner_id: userId });

  const refreshedUser = await findCampUserByEmail(user.email);
  if (!refreshedUser || String(refreshedUser?.owner_id ?? '') !== userId) {
    throw new Error('Your Camp profile ownership could not be saved.');
  }

  return refreshedUser;
}

export async function createOwnedCampUser(payload, email) {
  const createResponse = await api.post('users_gwacamp', payload);
  const userId = await resolveCreatedCampUserId(createResponse, email);
  const createdUser = await findCampUserByEmail(email);

  return ensureCampUserOwner({
    ...createdUser,
    id: createdUser?.id ?? userId
  });
}